import { render, staticRenderFns } from "./complaintSheet.vue?vue&type=template&id=0f98d529&scoped=true"
import script from "./complaintSheet.vue?vue&type=script&lang=js"
export * from "./complaintSheet.vue?vue&type=script&lang=js"
import style0 from "./complaintSheet.vue?vue&type=style&index=0&id=0f98d529&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f98d529",
  null
  
)

export default component.exports